
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lib/[pageNumber]",
      function () {
        return require("private-next-pages/lib/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lib/[pageNumber]"])
      });
    }
  